// extracted by mini-css-extract-plugin
export default {"label":"MenuCategoriesLabel_label__QoU57","mobileLabel":"MenuCategoriesLabel_mobileLabel__PIQ7W","customSpoilerButton":"MenuCategoriesLabel_customSpoilerButton__FxeMP"};